/* XHOBIES — scripts propios (vanilla, sin librerías externas) */
(function () {
  "use strict";

  function initReveal() {
    var els = document.querySelectorAll(".xh-reveal");
    if (!els.length) return;
    if (!("IntersectionObserver" in window) || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      els.forEach(function (el) { el.classList.add("xh-visible"); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("xh-visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initAmbientesTabs() {
    document.querySelectorAll("[data-xh-ad-tab]").forEach(function (tab) {
      tab.addEventListener("click", function () {
        var id = tab.getAttribute("data-xh-ad-tab");
        var tabsWrap = tab.closest(".xh-ad-tabs");
        var panelesWrap = tabsWrap ? tabsWrap.parentElement.querySelector(".xh-ad-paneles") : null;
        if (!panelesWrap) return;
        tabsWrap.querySelectorAll("[data-xh-ad-tab]").forEach(function (t) {
          var active = t === tab;
          t.classList.toggle("xh-ad-tab-activo", active);
          t.setAttribute("aria-selected", active ? "true" : "false");
        });
        panelesWrap.querySelectorAll("[data-xh-ad-panel]").forEach(function (p) {
          p.classList.toggle("xh-ad-panel-activo", p.getAttribute("data-xh-ad-panel") === id);
        });
      });
    });
  }

  function initAntesDespues() {
    document.querySelectorAll("[data-xh-comparador]").forEach(function (wrap) {
      var handle = wrap.querySelector("[data-xh-comparador-asa]");
      var despues = wrap.querySelector("[data-xh-comparador-despues]");
      var input = wrap.querySelector("[data-xh-comparador-input]");
      if (!handle || !despues || !input) return;

      function setPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        despues.style.clipPath = "inset(0 " + (100 - pct) + "% 0 0)";
        handle.style.left = pct + "%";
        input.value = pct;
      }
      setPos(parseFloat(input.value) || 50);

      input.addEventListener("input", function () { setPos(parseFloat(input.value)); });

      var dragging = false;
      function pointerToPct(clientX) {
        var rect = wrap.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }
      handle.addEventListener("pointerdown", function (e) {
        dragging = true;
        handle.setPointerCapture(e.pointerId);
      });
      handle.addEventListener("pointermove", function (e) {
        if (!dragging) return;
        setPos(pointerToPct(e.clientX));
      });
      handle.addEventListener("pointerup", function () { dragging = false; });
      wrap.addEventListener("click", function (e) {
        if (e.target === handle) return;
        setPos(pointerToPct(e.clientX));
      });
    });
  }

  function initGaleriaProducto() {
    document.querySelectorAll("[data-xh-galeria]").forEach(function (galeria) {
      var principal = galeria.querySelector("[data-xh-galeria-principal]");
      var thumbs = galeria.querySelectorAll("[data-xh-galeria-thumb]");
      if (!principal || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var full = thumb.getAttribute("data-full");
          var alt = thumb.getAttribute("data-alt") || "";
          if (!full) return;
          principal.style.opacity = "0";
          window.setTimeout(function () {
            principal.src = full;
            principal.alt = alt;
            principal.style.opacity = "1";
          }, 150);
          thumbs.forEach(function (t) { t.classList.remove("xh-thumb-activo"); });
          thumb.classList.add("xh-thumb-activo");
        });
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll("[data-xh-form-producto]").forEach(function (form) {
      var variantesRaw = form.querySelector("[data-xh-variantes-json]");
      var selects = form.querySelectorAll("[data-xh-opcion]");
      var inputId = form.querySelector("[data-xh-variant-id]");
      var key = form.dataset.xhFormProducto;
      var precio = document.querySelector("[data-xh-precio-actual='" + key + "']");
      var precioComparado = document.querySelector("[data-xh-precio-comparado='" + key + "']");
      var descuento = document.querySelector("[data-xh-descuento='" + key + "']");
      var botonComprar = form.querySelector("[data-xh-boton-comprar]");
      var galeriaPrincipal = document.querySelector("[data-xh-galeria-principal]");
      if (!variantesRaw || !selects.length || !inputId) return;

      var variantes;
      try { variantes = JSON.parse(variantesRaw.textContent); } catch (e) { return; }

      function gruposUnicos() {
        var vistos = [];
        selects.forEach(function (el) {
          var nombre = el.name || el.id;
          if (vistos.indexOf(nombre) === -1) vistos.push(nombre);
        });
        return vistos;
      }

      function valorDeGrupo(nombre) {
        var todos = form.querySelectorAll('[data-xh-opcion][name="' + nombre + '"]');
        if (!todos.length) return null;
        if (todos[0].tagName === "SELECT") return todos[0].value;
        var marcado = form.querySelector('[data-xh-opcion][name="' + nombre + '"]:checked');
        return marcado ? marcado.value : todos[0].value;
      }

      function variantePorOpciones() {
        var valores = gruposUnicos().map(valorDeGrupo);
        return variantes.find(function (v) {
          return v.options.every(function (opt, i) { return opt === valores[i]; });
        });
      }

      function actualizar() {
        var v = variantePorOpciones();
        if (!v) return;
        inputId.value = v.id;
        if (precio) precio.textContent = v.precioFormateado;
        if (precioComparado) {
          if (v.precioComparadoFormateado) {
            precioComparado.textContent = v.precioComparadoFormateado;
            precioComparado.style.display = "";
          } else {
            precioComparado.style.display = "none";
          }
        }
        if (descuento) {
          if (v.descuento) {
            descuento.textContent = "-" + v.descuento + "%";
            descuento.style.display = "";
          } else {
            descuento.style.display = "none";
          }
        }
        if (botonComprar) {
          botonComprar.disabled = !v.disponible;
          botonComprar.textContent = v.disponible ? botonComprar.dataset.textoDisponible : botonComprar.dataset.textoAgotado;
        }
        if (galeriaPrincipal && v.imagenUrl) {
          galeriaPrincipal.style.opacity = "0";
          window.setTimeout(function () {
            galeriaPrincipal.src = v.imagenUrl;
            galeriaPrincipal.alt = v.imagenAlt || "";
            galeriaPrincipal.style.opacity = "1";
          }, 150);
        }
      }

      selects.forEach(function (s) { s.addEventListener("change", actualizar); });
      actualizar();
    });
  }

  function initCantidad() {
    document.querySelectorAll("[data-xh-cantidad-input]").forEach(function (input) {
      var wrap = input.closest(".xh-prod-cantidad");
      if (!wrap) return;
      var menos = wrap.querySelector("[data-xh-cantidad-menos]");
      var mas = wrap.querySelector("[data-xh-cantidad-mas]");
      function setVal(v) {
        v = Math.max(1, parseInt(v, 10) || 1);
        input.value = v;
      }
      if (menos) menos.addEventListener("click", function () { setVal(parseInt(input.value, 10) - 1); });
      if (mas) mas.addEventListener("click", function () { setVal(parseInt(input.value, 10) + 1); });
      input.addEventListener("change", function () { setVal(input.value); });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveal();
    initAmbientesTabs();
    initAntesDespues();
    initGaleriaProducto();
    initVariantes();
    initCantidad();
  });
})();
